export default __webpack_public_path__ + "assets/ico-della-info-44d82914.svg";